import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import colors from '../../theme/colors';

import { BaseFont } from './styles';

export const TypographyComponent = ({
  align,
  children,
  className,
  component,
  color,
  italic,
  styles,
  uppercase,
  variant,
  weight,
  ...rest
}) => {
  const classNames = {};
  classNames[`nmx-${variant}`] = variant;
  classNames['nmx-uppercase'] = uppercase;
  classNames['nmx-italic'] = italic;
  classNames[`nmx-align-${align}`] = align && align !== 'inherit';
  classNames[className] = className;
  return (
    <BaseFont
      className={classnames(classNames, className)}
      as={component || 'p'}
      weight={weight}
      color={color}
      {...rest}
      style={styles || {}}>
      {children}
    </BaseFont>
  );
};

TypographyComponent.propTypes = {
  /** Alignment for text component */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right']),
  /** Disable the default bottom margin for variant */
  disableBottomPadding: PropTypes.bool,
  /** The inner content to be rendered */
  children: PropTypes.node.isRequired,
  /** Custom class name to add to Type. */
  className: PropTypes.string,
  /** Set of allowed colors */
  color: (props) => {
    if (
      !props.color
      || ([
        'color-neutral-black',
        'color-neutral-white',
        'color-neutral-gray-29',
        'color-neutral-gray-23',
        'color-primary-nm-blue',
        'color-hero-text-stroke',
        'color-system-dark-red',
      ].indexOf(props.color) < 0
        && !/^#([0-9A-F]{3}){1,2}$/i.test(props.color))
    ) {
      throw new Error(
        `Invalid color provided to Typography component: ${props.color}, please use a valid color name or hex value.`,
      );
    }
  },
  /** what the DOM element rendered should be */
  component: PropTypes.oneOf([
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'span',
    'div',
  ]),
  styles: PropTypes.object,
  /** What styled should be applied to the tag */
  variant: PropTypes.oneOf([
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'jumbo-type',
  ]),
  /** allows overriding of font-weight */
  weight: PropTypes.oneOf([100, 200, 300, 400, 500, 600, 700, 800, 900]), // TODO: name and export in a theme
};

TypographyComponent.defaultProps = {
  disableBottomPadding: false,
  className: null,
  color: colors.neutral.grey29,
  styles: null,
  component: 'p',
};

export default TypographyComponent;
